import AlertDialog from "@/v2-ui/alertDialog"
import Button from "@/v2-ui/button"
import { usePrimitiveText } from "@/v2-ui/text/offline"
import { useConfirmation } from "./confirmation.context"

function ConfirmationDialog() {
  const { confirmation, dismiss, setLoading } = useConfirmation()
  const { getText } = usePrimitiveText()

  const {
    open = false,
    isLoading = false,
    title = getText("UI_Primitive_ConfirmationDialog_Title").Name,
    description = getText("UI_Primitive_ConfirmationDialog_Description").Name,
    content,
    confirmText = getText("UI_Primitive_ConfirmationDialog_Confirm").Name,
    cancelText = getText("UI_Primitive_ConfirmationDialog_Cancel").Name,
    confirmVariant = "destructive",
    cancelVariant = "outline",
    onConfirm,
    onCancel,
  } = confirmation ?? {}

  async function handleConfirm() {
    if (isLoading) return

    const result = onConfirm?.()

    if (result && typeof result.then === "function") {
      setLoading(true)
      try {
        await result
      } finally {
        setLoading(false)
        dismiss()
      }
    } else {
      dismiss()
    }
  }

  function handleCancel() {
    if (isLoading) return
    onCancel?.()
    dismiss()
  }

  return (
    <AlertDialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen && !isLoading) {
          handleCancel()
        }
      }}
    >
      <AlertDialog.Content>
        <AlertDialog.Header>
          <AlertDialog.Title>{title}</AlertDialog.Title>
          {description && (
            <AlertDialog.Description>{description}</AlertDialog.Description>
          )}
        </AlertDialog.Header>

        {content && <div className="py-2">{content}</div>}

        <AlertDialog.Footer>
          <Button
            variant={cancelVariant}
            disabled={isLoading}
            onClick={handleCancel}
          >
            {cancelText}
          </Button>
          <Button
            variant={confirmVariant}
            isLoading={isLoading}
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog>
  )
}

export default ConfirmationDialog
